<template>
<div class="shopMobNavigation">
    <div v-for="(obj, index) in setting.datalist" :key="index" class="navBox" :style="'width:'+100/setting.datacount+'%'">
        <div class="navItem">
            <img v-lazy="obj.banner.furl" alt="">
            <div class="objectname">{{obj.objectname}}</div>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'shopMobNavigation',
    data() {
        return {}
    },
    mounted() {
    },
    props: ['setting'],
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopMobNavigation {
    @include flexBox(flex-start);
    flex-wrap: wrap;
    padding: 0.48rem 0;
    .navBox{
        box-sizing: border-box;
        padding: 0.2rem 0.05rem;
        @include flexBox(center);
        .navItem{
            img{
                width: 1.8rem;
                height: 1.8rem;
            }
            .objectname{
                margin-top: 0.32rem;
                height: 0.6rem;
                font-size: $mfont-48;
                text-align: center;
            }
        }
    }
}
</style>
